import { apiQuery } from "app/game-data/useQuery";

interface CreateFeedbackInput {
  gameId: string;
  body: string;
  email?: string;
  nps?: number;
}

const CREATE_FEEDBACK_MUTATION = /* GraphQL */ `
  mutation CreateFeedback($input: CreateFeedbackInput!) {
    feedback: createFeedback(input: $input) {
      id
    }
  }
`;

interface FeedbackResponse {
  feedback: {
    id: string;
  };
}

export default async function createFeedback({
  feedback,
  email,
  nps,
}: {
  feedback: string;
  email?: string;
  nps?: number;
}): Promise<{ data?: Partial<FeedbackResponse>; error?: boolean }> {
  const { data, error } = await apiQuery<
    FeedbackResponse,
    { input: CreateFeedbackInput }
  >(CREATE_FEEDBACK_MUTATION, {
    input: {
      gameId: `nonograms`,
      body: feedback,
      email,
      nps,
    },
  });

  if (!data?.feedback.id) {
    return { error };
  }

  return {
    data,
  };
}
